/** @file badgeLegend: the one-line legend of the tree's row badges (shown by the panel's info button). */

/** Keep in step with `NodeBadges`. */
export const badgeLegend = '◆ key at the playhead · IK<n> chain length · ⇄ mirror twin · ◎ socket · ⊘ hidden in data (fainter on children) · flex flexible parent · eye = viewport only';
